import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const Alignment = () => {
  const { t } = useLang();
  const A = t.alignment;

  return (
    <section
      id="alignment"
      data-testid="alignment-section"
      className="py-24 md:py-32 bg-navy text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none opacity-40" />
      <div className="absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full bg-coral/10 blur-3xl pointer-events-none" />

      <div className="container-vel relative grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <div
            className="overline mb-5 text-coral"
            data-testid="alignment-overline"
          >
            {A.overline}
          </div>
          <h2
            data-testid="alignment-heading"
            className="font-heading text-4xl sm:text-5xl text-white font-light leading-[1.05] tracking-tight"
          >
            {A.headlinePre}{" "}
            <em className="not-italic underline decoration-coral decoration-2 underline-offset-8">
              {A.headlineHighlight}
            </em>
            {A.headlinePost}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-7 lg:pl-8 lg:border-l lg:border-white/15"
        >
          <ul data-testid="alignment-paragraphs" className="space-y-5">
            {A.paragraphs.map((line, i) => (
              <li
                key={i}
                data-testid={`alignment-paragraph-${i}`}
                className="flex items-start gap-4"
              >
                <span className="mt-2 inline-block w-6 h-px bg-coral shrink-0" />
                <p className="font-body text-base sm:text-lg text-white/85 leading-relaxed font-light">
                  {line}
                </p>
              </li>
            ))}
          </ul>

          <div
            data-testid="alignment-pillars"
            className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4"
          >
            {A.pillars.map((p, i) => (
              <div
                key={p}
                data-testid={`alignment-pillar-${i}`}
                className="border border-white/15 px-6 py-5 hover:border-coral/70 transition-colors duration-500"
              >
                <p className="font-heading text-lg sm:text-xl text-white leading-snug">
                  {p}
                </p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Alignment;
